import {
  AlertCircle,
  CheckCircle2,
  MinusCircle,
  Wrench,
  XCircle,
} from "lucide-react";

function OperationalIcon() {
  return (
    <CheckCircle2 size={24} className="bg-green-600 text-white rounded-full" />
  );
}

function DegradedIcon() {
  return (
    <MinusCircle size={24} className="bg-yellow-500 text-white rounded-full" />
  );
}

function PartialIcon() {
  return (
    <AlertCircle size={24} className="bg-orange-500 text-white rounded-full" />
  );
}

function MajorIcon() {
  return <XCircle size={24} className="bg-red-500 text-white rounded-full" />;
}

function MaintenanceIcon() {
  return (
    <Wrench size={24} className="rounded-full bg-blue-400 text-white p-1" />
  );
}

const MAP_STATUS = {
  operational: {
    Icon: CheckCircle2,
    cls: "bg-green-600 text-white rounded-full",
  },
  "degraded-performance": {
    Icon: MinusCircle,
    cls: "bg-yellow-500 text-white rounded-full",
  },
  "partial-outage": {
    Icon: AlertCircle,
    cls: "bg-orange-500 text-white rounded-full",
  },
  "major-outage": {
    Icon: XCircle,
    cls: "bg-red-500 text-white rounded-full",
  },
  "under-maintenance": {
    Icon: MinusCircle,
    cls: "bg-blue-400 text-white rounded-full p-1",
  },
};

function ComponentStatusIcon({ statusSlug }) {
  const { Icon, cls } = MAP_STATUS[statusSlug] || {};

  if (Icon) {
    return <Icon className={cls} />;
  }
}

export default ComponentStatusIcon;
